import React from "react";
import Card from "../../components/Card";
import ClientForm from "./CreateNewForm/Clients";
import { useFormsData } from "./FormsData";
import "./index.scss";

const CreateNew = () => {
    const {
        activeTab,
        isSubmitting,
        clientFormData,
        clientErrors,
        setClientErrors,
        handleClientChange,
        handleClientBlur,
        handleSubmit,
        handleCancel,
        // handleTabChange,
    } = useFormsData();

    return (
        <div className="create-new-page">
            <h1 className="page-title">Create New Entity</h1>

            <Card>
                {/* <div
                    className="entity-type-selector"
                    style={{ display: "flex", gap: "24px", alignItems: "center" }}
                >
                    <div>
                        <label htmlFor="entityTypeSelect">Select Entity Type</label>
                        <select
                            id="entityTypeSelect"
                            value={activeTab}
                            onChange={(e) => handleTabChange(e.target.value)}
                            disabled={isSubmitting}
                            className="entity-type-dropdown"
                            style={{ marginLeft: "8px" }}
                        >
                            <option value="client">Client</option>
                            <option value="vendor">Vendor</option>
                        </select>
                    </div>
                    <div>
                        <label htmlFor="typeSelect">Select Type</label>
                        <select
                            id="typeSelect"
                            value={activeTab}
                            onChange={(e) => handleTabChange(e.target.value)}
                            disabled={isSubmitting}
                            className="entity-type-dropdown"
                            style={{ marginLeft: "8px" }}
                        >
                            <option value="Travel">Travel</option>
                            <option value="Mobile">Mobile</option>
                        </select>
                    </div>
                </div> */}
                <div className="form-container">
                    <ClientForm
                        formData={clientFormData}
                        errors={clientErrors}
                        onChange={handleClientChange}
                        onBlur={handleClientBlur}
                        onSubmit={(data) => handleSubmit(data, activeTab)}
                        onCancel={handleCancel}
                        setErrors={setClientErrors}
                        isSubmitting={isSubmitting}
                        entityType={activeTab}
                    />
                </div>
            </Card>
        </div>
    );
};

export default CreateNew;
